import { FC, PropsWithChildren, ReactNode, memo } from 'react';
import { useTranslation } from 'react-i18next';
import { Property } from 'csstype';
import { DEFAULT_TAG_STYLES } from 'configs/common';
import { EOrderBookingTypes } from 'types/api';
import { Tag, Tooltip } from 'antd';

const config: Record<EOrderBookingTypes, Property.Color> = {
	[EOrderBookingTypes.INSTANT]: 'blue',
	[EOrderBookingTypes.SCHEDULED]: 'orange',
};

interface IOrderBookingTypeTagProps {
	type: EOrderBookingTypes;
	tooltipText?: ReactNode;
}

export const OrderBookingTypeTag: FC<PropsWithChildren<IOrderBookingTypeTagProps>> = memo(
	({ type, tooltipText, children }) => {
		const { t: tCommon } = useTranslation('common');

		return (
			<Tooltip title={tooltipText}>
				<Tag
					color={config[type]}
					style={DEFAULT_TAG_STYLES}
				>
					{children ?? tCommon(`order.booking_types.${type}`)}
				</Tag>
			</Tooltip>
		);
	}
);
